export const sleep = (millis) => new Promise((resolve) => setTimeout(resolve, millis));
export const immediate = () => new Promise((resolve) => setImmediate(resolve));

export const arrayOrder = (order, target) => {
  const result = [];
  target.forEach(s => {
    const index = order.indexOf(s);
    result[index] = s;
  });
  return result.filter(x => x);
};